import router from "@/router"
router.beforeEach((to, form, next) => {
  if (to.path === '/login') {
    document.title = `欢迎来到唯格云移动版`
  } else {
    document.title = `唯格云 - ${to.meta.title}`
  }
  next();
})